import React from 'react';
import './servicios.css';

// Importar iconos profesionales de react-icons
import { FaCouch, FaPalette, FaTree } from 'react-icons/fa';
// Alternativa: puedes usar también Material Design Icons
// import { MdChair, MdDesignServices, MdForest } from 'react-icons/md';

const Servicios = () => {
  const servicios = [
    {
      id: 1,
      titulo: "VENTA DE MUEBLERÍA AL POR MAYOR Y MENOR EN TODO EL ECUADOR",
      descripcion: "Distribución nacional de muebles de calidad premium fabricados con madera de pino 100% natural",
      icono: <FaCouch className="servicio-icon-element" />,
      color: "#8B4513",
      delay: "0s"
    },
    {
      id: 2,
      titulo: "DISEÑO DE INTERIORES PERSONALIZADOS POR EL EXPERTO LIC. CARLOS AUCAPIÑA J",
      descripcion: "Asesoría profesional en diseño interior.",
      icono: <FaPalette className="servicio-icon-element" />,
      color: "#5D4037",
      delay: "0.2s"
    },
    {
      id: 3,
      titulo: "VENTA DE MADERA DE PINO",
      descripcion: "Madera de pino de primera calidad, secada y tratada para proyectos de carpintería y construcción",
      icono: <FaTree className="servicio-icon-element" />,
      color: "#DEB887",
      delay: "0.4s"
    }
  ];

  return (
    <section className="servicios-container">
      <div className="servicios-background">
        {/* Elementos decorativos de fondo */}
        <div className="wood-grain-1"></div>
        <div className="wood-grain-2"></div>
        <div className="wood-grain-3"></div>
      </div>
      
      <div className="servicios-content">
        <div className="servicios-header">
          <h2 className="servicios-titulo">NUESTROS SERVICIOS</h2>
          <div className="servicios-subtitulo">
            <span>Calidad y experiencia en cada proyecto</span>
            <div className="header-decoration"></div>
          </div>
        </div>

        <div className="servicios-grid">
          {servicios.map((servicio) => (
            <div 
              key={servicio.id} 
              className="servicio-card"
              style={{ 
                '--accent-color': servicio.color,
                '--animation-delay': servicio.delay
              }}
            >
              <div className="servicio-icon-container">
                <div className="servicio-icon">
                  {servicio.icono}
                </div>
                <div className="icon-background"></div>
              </div>

              <div className="servicio-content">
                <h3 className="servicio-titulo">{servicio.titulo}</h3>
                <p className="servicio-descripcion">{servicio.descripcion}</p>
              </div>

              {/* Efectos decorativos */}
              <div className="card-wood-grain"></div>
              <div className="card-saw-marks"></div>
              <div className="card-knots">
                <div className="knot knot-1"></div>
                <div className="knot knot-2"></div>
                <div className="knot knot-3"></div>
              </div>
            </div>
          ))}
        </div>

       
      </div>
    </section>
  );
};

export default Servicios;